import { render, staticRenderFns } from "./RecollectDataTable.vue?vue&type=template&id=73b82cdf"
import script from "./RecollectDataTable.vue?vue&type=script&lang=js"
export * from "./RecollectDataTable.vue?vue&type=script&lang=js"
import style0 from "./RecollectDataTable.vue?vue&type=style&index=0&id=73b82cdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports